import * as React from 'react'

import { twMerge } from 'tailwind-merge'

interface BadgeProps {
  children: React.ReactNode
  className?: string
}

export const Badge: React.FC<BadgeProps> = ({ children, className }) => {
  return (
    <div
      className={twMerge(
        'bg-white text-[#0F0F0F] font-medium rounded-full px-2 py-1 text-xs',
        className,
      )}
    >
      {children}
    </div>
  )
}
